import apiFetch from '../apiFetch'

export default function (idGrupoVerraco, token) {
  return apiFetch({endPoint: `GrupoVerraco/getGrupoVerraco?idGrupoVerraco=${idGrupoVerraco}`, method: 'GET', body: null, token: token})
}